import React from 'react';
import SearchStockCarousel from '../../molecules/search-stock-carousel';
import get from 'lodash/get';
import RightSidebar from '../../molecules/right-side-bar';
import './search.m.css';
import { sortStoriesByLastUpdatedAt } from '../../../helpers/utils';
import CardWithTime from '../../molecules/card-with-time';
import GenericTitle from '../../molecules/titles/generic-title';
import Noresult from '../../atoms/noresult';
import SearchResults from './search-results';

const SearchPage = props => {
  const params = {
    textStories: get(props, ['data', 'textStories'], []),
    videoStories: get(props, ['data', 'videoStories'], []),
    researchReports: get(props, ['data', 'researchReports'], []),
    stockSearchData: get(props, ['data', 'stockData'], []),
    baseApi: get(props, ['data', 'baseApi'], ''),
    hostImage: get(props, ['config', 'cdn-image'], ''),
    showVideo: true,
    fullWidthResult: true,
    searchTerm: get(props, ['data', 'query'], '').toLowerCase(),
    latest: get(props, ['data', 'latest', 'collection', 'items'], []),
    pagetype: get(props, ['data', 'pageType'], '')
  };

  const allLatest = params?.latest?.map(latest => {
    return latest.items ?? [];
  });
  const latest = [].concat.apply([], allLatest) ?? [];
  const topNews = sortStoriesByLastUpdatedAt(latest?.map(item => item?.story)) ?? [];
  const showResults = [
    params.textStories.items,
    params.videoStories.items,
    params.researchReports.items
  ].some(results => results?.length > 0);

  const tags = [
    { name: 'GST', path: 'gst' },
    { name: 'Mutual Funds', path: 'mutual-funds' },
    { name: 'Businessweek', path: 'businessweek' },
    { name: 'Research reports', path: 'research-reports' },
    { name: 'Cryptocurrency', path: 'crypto' },
    { name: 'Coronavirus', path: 'coronavirus-outbreak' },
    { name: 'Technology', path: 'technology' }
  ];

  const heading = showResults ? `Search Results For` : null;
  let hidden;

  if (typeof window !== 'undefined')
    if (window.location.search === '?q=all+you+need+to+know') {
      hidden = true;
    }

  return (
    <div className="container">
      {showResults ? (
        <div styleName="top-bg-with-search-title" className="section-fluid">
          <div className="container">
            <span>{heading}</span>
          </div>
        </div>
      ) : null}
      <div styleName="search-results-with-sidebar">
        <div
          styleName="search-results-left-side"
          style={showResults ? { transform: 'translateY(-33px)' } : {}}
        >
          {showResults ? (
            <SearchResults searchTerm={params.searchTerm} />
          ) : (
            <div>
              <Noresult query={params.searchTerm} tags={tags} />
              <GenericTitle title="YOU MAY ALSO LIKE" href="#" />
              <CardWithTime stories={topNews} noOfStories={20} />
            </div>
          )}
        </div>
        <div>
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export { SearchPage };
